import { slokaImageUrl } from './mediaUrls';

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
  if (!text) return y;
  const words = text.split(' ');
  let line = '';
  let linesDrawn = 0;

  for (const word of words) {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      if (linesDrawn >= maxLines - 1) {
        ctx.fillText(`${line.trim()}…`, x, y);
        return y + lineHeight;
      }
      ctx.fillText(line.trim(), x, y);
      line = word;
      y += lineHeight;
      linesDrawn++;
    } else {
      line = test;
    }
  }
  if (line) ctx.fillText(line.trim(), x, y);
  return y + lineHeight;
}

export async function generateShareCard(sloka) {
  const W = 1200;
  const H = 630;
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  // Background
  const bg = ctx.createLinearGradient(0, 0, W, H);
  bg.addColorStop(0, '#2D0A0F');
  bg.addColorStop(1, '#120404');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  // Decorative top/bottom gold lines
  ctx.strokeStyle = '#B8860B';
  ctx.lineWidth = 1;
  ctx.globalAlpha = 0.5;
  ctx.beginPath(); ctx.moveTo(40, 20); ctx.lineTo(W - 40, 20); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(40, H - 20); ctx.lineTo(W - 40, H - 20); ctx.stroke();
  ctx.globalAlpha = 1;

  // Try to draw sloka art on the left (cross-origin may fail)
  const artW = W * 0.4;
  try {
    const artUrl = slokaImageUrl(sloka.chapterNumber, sloka.slokaNumber);
    const img = await loadImage(artUrl);
    ctx.save();
    ctx.drawImage(img, 0, 0, artW, H);
    // Gradient fade on right edge of image
    const fade = ctx.createLinearGradient(artW * 0.5, 0, artW, 0);
    fade.addColorStop(0, 'rgba(45,10,15,0)');
    fade.addColorStop(1, 'rgba(45,10,15,1)');
    ctx.fillStyle = fade;
    ctx.fillRect(0, 0, artW, H);
    ctx.restore();
  } catch {
    // No art — just gradient background. Fine.
  }

  const textX = W * 0.43;
  const textMaxW = W - textX - 50;
  let y = 70;

  // ॐ
  ctx.fillStyle = '#D97706';
  ctx.font = 'bold 44px serif';
  ctx.fillText('ॐ', textX, y);
  y += 56;

  // Chapter · Verse label
  ctx.fillStyle = '#D97706';
  ctx.font = '600 16px sans-serif';
  ctx.letterSpacing = '2px';
  ctx.fillText(`CHAPTER ${sloka.chapterNumber}  ·  VERSE ${sloka.slokaNumber}`, textX, y);
  ctx.letterSpacing = '0px';
  y += 28;

  // Thin gold divider
  ctx.strokeStyle = '#D97706';
  ctx.lineWidth = 1;
  ctx.globalAlpha = 0.5;
  ctx.beginPath(); ctx.moveTo(textX, y); ctx.lineTo(W - 50, y); ctx.stroke();
  ctx.globalAlpha = 1;
  y += 24;

  // Sanskrit/vernacular sloka text
  ctx.fillStyle = 'rgba(255,255,255,0.92)';
  ctx.font = '22px serif';
  y = wrapText(ctx, sloka.sloka || '', textX, y, textMaxW, 34, 4);
  y += 16;

  // Second divider
  ctx.globalAlpha = 0.3;
  ctx.beginPath(); ctx.moveTo(textX, y); ctx.lineTo(W - 50, y); ctx.stroke();
  ctx.globalAlpha = 1;
  y += 24;

  // Meaning text
  ctx.fillStyle = 'rgba(255,255,255,0.68)';
  ctx.font = '19px sans-serif';
  y = wrapText(ctx, sloka.meaning || '', textX, y, textMaxW, 30, 5);

  // Speaker badge
  if (sloka.speaker) {
    ctx.fillStyle = 'rgba(217,119,6,0.7)';
    const badgeY = H - 80;
    const badgeText = `— ${sloka.speaker}`;
    ctx.font = 'italic 15px serif';
    ctx.fillText(badgeText, textX, badgeY);
  }

  // Branding footer
  ctx.fillStyle = 'rgba(255,255,255,0.3)';
  ctx.font = '13px sans-serif';
  ctx.fillText('Bhagavad Gita — Study & Listen', textX, H - 38);

  return new Promise((resolve, reject) => canvas.toBlob(
    (blob) => blob ? resolve(blob) : reject(new Error('Canvas toBlob failed')),
    'image/png'
  ));
}
